import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Login from './Account/Login/Login'
import Legal from './Account/Legal/Legal'
import Register from './Account/Register/Register'
import Recover from './Account/Recover/Recover'
import ChangePass from './Account/ChangePass/ChangePass'
import Verification from './Account/Verification/Verification'
import Associate from './Account/Associate/Associate'

declare const __CLIENT__: boolean

const LoginRedirect = () => {
  const ready = useSelector((state) => state.ready) // Acceso al estado con Redux
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (__CLIENT__ && ready) {
      const back = location.pathname + (location.search || '')
      navigate('/', { state: { back }, replace: true })
    }
  }, [ready, location, navigate])

  return null // Este componente no renderiza nada
}

const PublicRoutes = () => (
  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/recover" element={<Recover />} />
    <Route path="/verification" element={<Verification />} />
    <Route path="/change-pass/:user/:token" element={<ChangePass />} />
    <Route path="/change-pass" element={<ChangePass />} />
    <Route path="/legal" element={<Legal />} />
    <Route path="/mfa/associate/:id/:secret" element={<Associate />} />
    <Route path="*" element={<LoginRedirect />} />
  </Routes>
)

export default PublicRoutes
